import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';

// Pages
import Header from './Components/Header';
import Home from './Pages/Home';
import About from './Pages/About';
import Projects from './Pages/Projects';
import Homelab from './Projects/Homelab';
import Particle from './Projects/Particle';
import Bigfoot from './Projects/Bigfoot';

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/homelab" element={<Homelab />} />
        <Route path="/partical" element={<Particle />} />
        <Route path="/bigfoot" element={<Bigfoot />} />
      </Routes>
    </>
  );
}

export default App;
